import {
    FORGOT_PASSWORD_REQUEST,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD_FAILURE,
    CLEAR_FORGOT_PASSWORD_STATE,
  } from "../actions/AppForgetPasswordAction";
  
  const initialState = {
    loading: false,
    success: false,
    error: null,
    message: "",
  };
  
  const forgotPasswordReducer = (state = initialState, action) => {
    switch (action.type) {
      case FORGOT_PASSWORD_REQUEST:
        return { ...state, loading: true, success: false, error: null, message: "" };
  
      case FORGOT_PASSWORD_SUCCESS:
        return {
          ...state,
          loading: false,
          success: true,
          error: null,
          message: action.payload,
        };
  
      case FORGOT_PASSWORD_FAILURE:
        return {
          ...state,
          loading: false,
          success: false,
          error: action.payload,
          message: "",
        };
  
      case CLEAR_FORGOT_PASSWORD_STATE:
        return { ...initialState };
  
      default:
        return state;
    }
  };
  
  export default forgotPasswordReducer;
  